<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          contain
          :max-width="cartDetail.width || 50"
          :src="cartDetail ? require(`@/assets/conectiontab/${cartDetail.src}`) : '' "
          :class="cartDetail.class ||'mx-3 mt-4'"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          {{ cartDetail.pageHeading }}
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          v-track="`close-${cartType}-detail-drawer`"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card
        outlined
        class="update-card mb-5"
      >
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon
              color="#3FD06F"
              class="mr-3"
              style="font-size:35px;"
            >
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Added</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p>
                You just added the {{ cartType.pageHeading }} integration.
                We are syncing the data right now and you should check back in a few minutes.
                As you continue to use {{ cartType.pageHeading }},
                We will automatically keep that data in sync with Maropost.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
     <div :id="`${cartType}-intergration-details`">
        <h2>Integration Info</h2>
        <v-sheet
          v-if="isLoading"
          class="pa-3"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            :loading="isLoading"
          />
        </v-sheet>

        <div
          v-else
          class="mt-5 py-2 px-3 bg-grey"
        >
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Merchant ID
            </v-col>
            <v-col class="py-0">
              {{ storeData.merchant_id }}
            </v-col>
          </v-row>
          <v-row 
            v-if="storeData.merchant_key"
            class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Merchant Key
            </v-col>
            <v-col class="py-0">
              {{ storeData.merchant_key }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Status
            </v-col>
            <v-col class="py-0">
              <v-chip
                color="success"
                outlined
                small
              >
                Active
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>

      <div class="my-5">
        <h2>{{ cartDetail.pageHeading }} Fields Mapping to Maropost Fields</h2>
        <v-simple-table
          outlined
          class="mt-5 field-table"
        >
          <thead class="bg-grey">
            <tr>
              <th class="text-left">
                Maropost Fields
              </th>
              <th class="text-left">
                {{ cartType.pageHeading }} Fields
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(field, fieldIndex) in Object.keys(fields)"
            >
              <tr
                :key="`parent_${fieldIndex}`"
                class="bg-grey"
              >
                <td>{{ field | underscoreRemover }}</td>
                <td />
              </tr>
              <tr
                v-for="(key, index) in Object.keys(fields[field])"
                :key="index"
              >
                <td>
                  {{ key }}
                </td>
                <td>
                  {{ fields[field][key] }}
                </td>
              </tr>
            </template>
            <tr
              v-for="(field, index) in Fields"
              :key=" `order${index}`"
            >
              <td :class="{ 'bg-grey': field.cart == '' }">
                {{ field.maropost }}
              </td>
              <td :class="{ 'bg-grey': field.cart == '' }">
                {{ field.cart }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

      <v-btn
        :v-track="`${cartType}-store-index`"
        dark
        :to="`/accounts/${$store.getters['auth/account'].id}/integrations/${cartType}`"
        class="mb-5"
        @click="navigateIndexPage()"
      >
        Done
      </v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'CartDetailDrawer',
    data () {
      return {
        isLoading: false,
        fields: {},
        storeData: {},
        Fields: [],
        ultraCartFields: [
          {
            maropost: 'For Orders:',
            cart: '',
          },
          {
            maropost: 'grand_total',
            cart: 'total'
          },
          {
            maropost: 'original_order_id',
            cart: 'order_id'
          },
          {
            maropost: 'order_date',
            cart: 'order_date'
          },
          {
            maropost: 'order_status',
            cart: 'payment_status'
          },
          {
            maropost: 'For Contacts:',
            cart: '',
          },
          {
            maropost: 'first_name',
            cart: 'bill_to_first_name'
          },
          {
            maropost: 'last_name',
            cart: 'bill_to_last_name'
          },
          {
            maropost: 'email',
            cart: 'email'
          },
          {
            maropost: 'For Items:',
            cart: '',
          },
          {
            maropost: 'item_id',
            cart: 'item_id'
          },
          {
            maropost: 'quantity',
            cart: 'quantity'
          },
          {
            maropost: 'description',
            cart: 'description'
          },
          {
            maropost: 'price',
            cart: 'cost'
          }
        ],
        threedCartFields: [
          {
            maropost: 'For Orders:',
            cart: '',
          },
          {
            maropost: 'grand_total',
            cart: 'Total'
          },
          {
            maropost: 'original_order_id',
            cart: 'OrderID'
          },
          {
            maropost: 'order_date',
            cart: 'Date'
          },
          {
            maropost: 'order_status',
            cart: 'OrderStatus'
          },
          {
            maropost: 'For Contacts:',
            cart: '',
          },
          {
            maropost: 'first_name',
            cart: 'FirstName'
          },
          {
            maropost: 'last_name',
            cart: 'LastName'
          },
          {
            maropost: 'email',
            cart: 'Email'
          },
          {
            maropost: 'For Items:',
            cart: '',
          },
          {
            maropost: 'item_id',
            cart: 'ProductID'
          },
          {
            maropost: 'quantity',
            cart: 'Quantity'
          },
          {
            maropost: 'description',
            cart: 'ProductName'
          },
          {
            maropost: 'price',
            cart: 'UnitPrice'
          }
        ],
        nanacastCartFields: [
          {
            maropost: 'For Orders:',
            cart: '',
          },
          {
            maropost: 'grand_total',
            cart: 'u_first_price'
          },
          {
            maropost: 'original_order_id',
            cart: 'u_last_transaction_id'
          },
          {
            maropost: 'order_date',
            cart: 'u_date_added'
          },
          {
            maropost: 'order_status',
            cart: ''
          },
          {
            maropost: 'For Contacts:',
            cart: '',
          },
          {
            maropost: 'first_name',
            cart: 'u_firstname'
          },
          {
            maropost: 'last_name',
            cart: 'u_lastname'
          },
          {
            maropost: 'email',
            cart: 'u_email'
          },
          {
            maropost: 'For Items:',
            cart: '',
          },
          {
            maropost: 'item_id',
            cart: 'u_list_id'
          },
          {
            maropost: 'quantity',
            cart: 'u_quantity'
          },
          {
            maropost: 'description',
            cart: 'item_name'
          },
          {
            maropost: 'price',
            cart: 'u_first_price'
          }
        ],
        shoppingCartFields: [
          {
            maropost: 'For Orders:',
            cart: '',
          },
          {
            maropost: 'grand_total',
            cart: 'GrandTotal'
          },
          {
            maropost: 'original_order_id',
            cart: 'Id'
          },
          {
            maropost: 'order_date',
            cart: 'OrderDate'
          },
          {
            maropost: 'order_status',
            cart: 'OrderStatusType'
          },
          {
            maropost: 'For Contacts:',
            cart: '',
          },
          {
            maropost: 'first_name',
            cart: 'FirstName'
          },
          {
            maropost: 'last_name',
            cart: 'LastName'
          },
          {
            maropost: 'email',
            cart: 'Email'
          },
          {
            maropost: 'phone',
            cart: 'Phone'
          },
          {
            maropost: 'For Order Items:',
            cart: '',
          },
          {
            maropost: 'item_id',
            cart: "ProductId['__content__']"
          },
          {
            maropost: 'quantity',
            cart: 'Quantity'
          },
          {
            maropost: 'description',
            cart: 'ProductName'
          },
          {
            maropost: 'price',
            cart: 'UnitPrice'
          }
        ],
        isMounted: false
      }
    },
    computed: {
      cartType() {
        return this.$route.params.cartType || this.$store.getters['ui/drawer'].right.cartType;
      },
      cartDetail () {
        let cartObj = {}
        switch (this.cartType) {
          case '1shoppingcart':
            cartObj = {
              pageHeading: '1ShoppingCart',
              src: '1sshopping-drawer.png',
              link: '',
              payloadCardType: 'one_shopping_cart',
              width: 35,
              class: 'mx-3 mt-0',
              fieldsListName: 'shoppingCartFields'
            }
            break
          case 'ultracart':
            cartObj = {
              pageHeading: 'UltraCart',
              src: 'ultracart.png',
              link: '',
              payloadCardType: 'ultra_cart',
              width: 30,
              class: 'mx-3 mt-0',
              fieldsListName: 'ultraCartFields'
            }
            break
          case 'nanacastcart':
            cartObj = {
              pageHeading: 'Nanacast',
              src: 'logo.png',
              link: '',
              payloadCardType: 'nanacast_cart',
              class: 'ml-3 mr-2 mt-1',
              width: 40,
              fieldsListName: 'nanacastCartFields'
            }
            break
          case 'shift4shop':
            cartObj = {
              pageHeading: 'Shift4Shop',
              src: '3dcart_logo.png',
              link: '',
              payloadCardType: '3d_cart',
              class:"mx-3 mt-0",
              fieldsListName: 'threedCartFields'
            }
            break
        }
        return cartObj
      },
    },
    mounted() {
      this.isLoading  = true;
      this.Fields = this[this.cartDetail.fieldsListName];
      if (this.$store.getters['ui/drawer'].right.storeData.data &&
        this.$store.getters['ui/drawer'].right.storeData.data.id
      ) {
        const data = this.$store.getters['ui/drawer'].right.storeData.data
        this.storeData = data;
      }
      this.isLoading  = false
      this.isMounted  = true;
    },
    beforeDestroy () {
      this.isMounted = false
      this.navigateIndexPage()
    },
    methods: {
      navigateIndexPage () {
        localStorage.removeItem('selected_integration_list_name')
        this.$router.push({
          name: `Cart_index`,
          query: { t: new Date().getTime() },
          params: {
            cartType: this.cartType
          }
        })
      },
    },
  }
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
